<template>
  <div :class="$style.box">
    <div :class="$style.content" :style="{ height: dialogHeight, marginTop: dialogMarginTop }">
      <div :class="$style.title">
        <slot name="title"></slot>
      </div>
      <div :class="$style.main">
        <slot name="main-content"></slot>
      </div>
      <div :class="$style.footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogType: {
      type: String,
      default: ''
    },
    dialogHeight: {
      type: String,
      default: '235px'
    },
    dialogMarginTop: {
      type: String,
      default: '35%'
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit('closeDialog')
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.box {
  position: absolute;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.65);
  .content {
    position: relative;
    padding: 17px 15px 0 15px;
    margin: auto;
    width: 351px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .title {
      font-size: 20px;
      text-align: center;
      color: '#000000';
    }
    .main {
      margin-top: 10px;
      padding-bottom: 80px;
      width: 100%;
      min-height: 178px;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #9f9f9f;
    }
    .footer {
      @include vertical-center;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 50px;
    }
  }
  :global {
    .yw-close {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      color: #ffffff;
      font-size: 50px;
      z-index: 1;
      margin: auto;
      font-weight: 100;
    }
  }
}
</style>
